import type { IInteractionRpc } from "@pulse-ui/codegen/generated_ts/managed_algo";

export type DefaultSlot =
    | "start"
    | "stop"
    | "update"
    | "pause"
    | "delete"
    | "resume";

export interface DefaultRpcEntry {
    slot: DefaultSlot;
    rpcName: string;
    schema: any;
}

/**
 * Returns the list of default RPCs (start/stop/etc) from one connection's interaction blob.
 * Uses codegen IInteractionRpc; at runtime default_rpcs is a plain object (slot -> { rpcName: schema }).
 */
export function getDefaultRpcEntries(
    interaction: IInteractionRpc
): DefaultRpcEntry[] {
    const result: DefaultRpcEntry[] = [];
    const defaultRpcs = interaction.rpcs?.default_rpcs as unknown as Record<string, Record<string, any>> | undefined;
    if (!defaultRpcs || typeof defaultRpcs !== "object") return result;

    for (const [slotKey, value] of Object.entries(defaultRpcs)) {
        const slot = slotKey as DefaultSlot;
        if (!value || typeof value !== "object") continue;

        const rpcNames = Object.keys(value);
        if (rpcNames.length === 0) continue;          // e.g. arber "pause": {}
        const rpcName = rpcNames[0];                  // by contract there's only one
        const schema = value[rpcName];

        if (!schema || typeof schema !== "object") continue;
        result.push({ slot, rpcName, schema });
    }

    return result;
}